import CompanyFilter
    from "@SearchResults/features/sidebar/features/companyFilters/components/CompanyFilter";
import CompanyScoreFilter from "@SearchResults/features/sidebar/features/companyFilters/components/CompanyScoreFilter";
import {SearchResultsRtkQueryResponseType} from "@SearchResults/api/types/SearchResultsRtkQueryResponse.type";
import ParamsType from "@SearchResults/types/params/Params.type";

type CarrierFiltersProps = {
    searchData: SearchResultsRtkQueryResponseType,
    params?: ParamsType
}

const CompanyFilters = ({searchData, params}: CarrierFiltersProps) => (
    <>
        <CompanyFilter
            searchData={searchData}
            params={params}
        />
        <CompanyScoreFilter
            searchData={searchData}
            params={params}
        />
    </>
);

export default CompanyFilters;